export default __webpack_public_path__ + "static/media/memories_9.3e8ee59c.png";